import { useNavigate } from "react-router-dom";
import { useClientAuth } from "../../contexts/ClientAuthContext";
import { Barbell, CheckSquare, ClipboardText, UsersThree, ChatCircleText, SignOut } from "@phosphor-icons/react";

const TABS = [
  { key: "workout", label: "Workout", icon: Barbell },
  { key: "habits", label: "Habits", icon: CheckSquare },
  { key: "checkin", label: "Check-in", icon: ClipboardText },
  { key: "community", label: "Community", icon: UsersThree },
  { key: "messages", label: "Coach", icon: ChatCircleText },
];

export default function PortalTopbar({ tab, setTab, clientName, clientPicture }) {
  const { logout } = useClientAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/portal-login");
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <div className="max-w-5xl mx-auto px-6 h-20 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {clientPicture ? (
            <img src={clientPicture} className="w-9 h-9 rounded-full object-cover" alt={clientName} />
          ) : (
            <div className="w-9 h-9 rounded-full bg-[#D4AF37]/20 text-[#D4AF37] flex items-center justify-center font-heading">{clientName?.[0]}</div>
          )}
          <div>
            <p className="text-sm text-white font-semibold">{clientName}</p>
            <p className="text-xs text-[#71717A]">Exist Fit Client</p>
          </div>
        </div>
        <div className="hidden sm:flex items-center gap-1 bg-white/5 rounded-full p-1">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <button
                key={t.key}
                data-testid={`portal-tab-${t.key}`}
                onClick={() => setTab(t.key)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-xs transition-colors ${
                  tab === t.key ? "bg-[#D4AF37] text-black font-semibold" : "text-[#A1A1AA] hover:text-white"
                }`}
              >
                <Icon size={14} /> {t.label}
              </button>
            );
          })}
        </div>
        <button data-testid="portal-logout-button" onClick={handleLogout} className="text-[#A1A1AA] hover:text-white">
          <SignOut size={20} />
        </button>
      </div>
      <div className="sm:hidden flex overflow-x-auto gap-1 px-4 pb-3">
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <button
              key={t.key}
              data-testid={`portal-tab-mobile-${t.key}`}
              onClick={() => setTab(t.key)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-xs whitespace-nowrap transition-colors ${
                tab === t.key ? "bg-[#D4AF37] text-black font-semibold" : "text-[#A1A1AA] bg-white/5"
              }`}
            >
              <Icon size={14} /> {t.label}
            </button>
          );
        })}
      </div>
    </header>
  );
}
